import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isNumber, isEmpty } from 'lodash';
import FontIcon from 'components/FontIcon';
import Link from 'components/Link';
import SeminarLocation from 'components/SeminarDetails/SeminarLocation';
import SeminarDateTime from 'components/SeminarDetails/SeminarDateTime';
import { Desktop, Default, Mobile, MobileOrTablet } from 'components/Responsive';
import BuildChildren from 'utils/BuildChildren';
import { priceFormatter } from 'utils/Numbers';
import { compareWithOnlineAddress } from 'utils/Seminar';
import SeminarDetailsModal from 'components/SeminarDetails/SeminarDetailsModal';
import AffirmContainer from 'containers/AffirmContainer/AffirmContainer';
import Modal from 'react-modal';
import ModalB from 'components/Modal/ModalB';
import InstructorB from 'components/Instructor/InstructorB';
import { displayType } from 'containers/ProductSearchContainer/ProductSearchTypes';
import classes from './CardProductH.module.scss';

class CardProductH extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showDetails: false,
      showPopup: false,
      isOpen: false,
      selectedInstructor: null,
    };

    this.toggleDetails = this.toggleDetails.bind(this);
    this.togglePopup = this.togglePopup.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal = (e, instructorObj) => {
    e.preventDefault();
    e.stopPropagation();
    const { isOpen } = this.state;
    this.setState({
      isOpen: !isOpen,
      selectedInstructor: instructorObj,
    });
  };

  toggleDetails() {
    const { showDetails } = this.state;
    this.setState({ showDetails: !showDetails });
  }

  togglePopup() {
    const { showPopup } = this.state;
    this.setState({ showPopup: !showPopup });
  }

  render() {
    const {
      displayName,
      price,
      originalPrice,
      description,
      button,
      creditHours = [],
      skillLevel,
      approvalText,
      seminarInfo,
      subjects = [],
      isAffirmEligible,
      productDetailUrl,
      url,
      displayConfiguration,
      deliveryType,
    } = this.props;

    const {
      venue,
      street,
      city,
      state,
      postalCode,
      start,
      end,
      timeZone,
      sessions = [],
      instructor,
      instructorsDetails = [],
      seatsRemaining,
    } = seminarInfo || {};

    const hasProductDetailPage = productDetailUrl && url;

    const { showPopup, showDetails } = this.state;
    const minSeatCount = 10;

    const showDeliveryType = deliveryType && displayConfiguration === displayType.NASBA;
    const shouldShowMoreInfo = !hasProductDetailPage && ((showDetails && seminarInfo) || !seminarInfo);

    const seatsLeftLabel = isNumber(seatsRemaining) && seatsRemaining < minSeatCount &&
      `${seatsRemaining > 0 ? seatsRemaining : 'No'} Seats Left`;

    const renderInstructor = () => (
      (instructorsDetails && instructorsDetails.map((i, idx) => {
        const { name, title } = i;
        const exists = !isEmpty(title);
        const br = idx > 0 ? <br /> : null;
        const instructorContent = (exists && (
          <button
            className={classes.instructorButton}
            type='button'
            onClick={(e) => this.toggleModal(e, i)}
          >
            <div dangerouslySetInnerHTML={{ __html: name }} />
          </button>
        )) || <div dangerouslySetInnerHTML={{ __html: name }} />;
        return (
          <div key={`${name}-${idx}`}>
            {instructorContent}
            {br}
          </div>
        );
      })) || (instructor &&
        <div>
          {instructor}
        </div>
      )
    );

    const descriptionLabel = () => (description &&
      <div className={classNames(classes.detailsWrapperBase, !seminarInfo ? classes.detailsWrapper : null)}>
        <div className={classNames(classes.detailsContainer, !shouldShowMoreInfo && classes.hide)}>
          <div
            className={showDetails ? classes.details : classes.detailsFaded}
            dangerouslySetInnerHTML={{ __html: description }}
          />
          {!seminarInfo &&
            <div className={classNames(classes.detailsOverflow, showDetails ? classes.hide : null)} />}
        </div>
        {!hasProductDetailPage &&
          <button
            aria-label={showDetails ? 'Less Details' : 'More Details'}
            className={classes.detailsButton}
            onClick={this.toggleDetails}
            type='button'
          >
            <FontIcon
              icon={showDetails ? 'far fa-minus-circle' : 'far fa-plus-circle'}
              className={classes.detailsButtonIcon}
            />
            {showDetails ? 'Less Details' : 'More Details'}
          </button>}
        {hasProductDetailPage && <Link
          href={productDetailUrl}
          className={classes.detailsButton}
          dangerouslySetInnerHTML={{ __html: 'View Details' }}
        />}
      </div>);

    // Render a single line with all subjects separated by commas on desktop
    // Render a single subject name per line on mobile
    // In order to avoid using JS solutions (Responsive widget), we let css handle when
    // it should display or not the commas
    const renderSubject = (subject, index, isLast) => (
      <span className={classes.subjectName} key={`subject-${index}`}>
        {subject}
        {!isLast && <span className={classes.commaSeparator} key={index}>,</span>}
      </span>
    );

    if (button) {
      button.className = classes.cartButtonAMobile;
    }

    const buildLabel = (labelTitle, labelText, labelContent, labelFooter) => (
      <div className={classNames('row', classes.gridRow)}>
        <Desktop>
          <div className={classNames('col-2', classes.gridLabel)}>
            {labelTitle}:
          </div>
          {labelText &&
            <div className={classNames('col-6', classes.gridValue)}>
              {renderInstructor()}
            </div>}
          {!labelText && labelContent &&
            <div className={classNames('col-6', classes.gridValue)}>
              {labelContent}
            </div>}
          {labelFooter}
        </Desktop>
        <MobileOrTablet>
          <div className={classNames('col-3', classes.gridLabel)}>
            {labelTitle}:
          </div>
          {labelText &&
            <div className={classNames('col-6', classes.gridValue)}>
              {renderInstructor()}
            </div>}
          {!labelText && labelContent &&
            <div className={classNames('col-6', classes.gridValue)}>
              {labelContent}
            </div>}
          {labelFooter}
        </MobileOrTablet>
      </div>
    );

    const isOnlineAddress = compareWithOnlineAddress(city);
    const { isOpen, selectedInstructor } = this.state;

    return (
      <div className={classes.container}>
        <Modal
          isOpen={isOpen}
          onRequestClose={(e) => this.toggleModal(e, null)}
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
          className={classes.modal}
          overlayClassName={classes.overlayModal}
          closeTimeoutMS={250}
        >
          <ModalB hideModal={(e) => this.toggleModal(e, null)}>
            <InstructorB {...selectedInstructor} title='Instructor BIO' />
          </ModalB>
        </Modal>
        <div className={classNames(classes.wrapper, description && seminarInfo ? classes.wrapperHeight : null)}>
          <div className={classes.left}>
            {displayName &&
              <h2
                className={classes.displayName}
                dangerouslySetInnerHTML={{ __html: displayName }}
              />}
            {subjects && subjects.length > 0 &&
              <div className={classes.subjectsContainer}>
                {subjects.map((sub, i) => renderSubject(sub, i, i === subjects.length - 1))}
              </div>}
            {price >= 0 && <div className={classes.price}>{priceFormatter(price)}</div>}
            {originalPrice > price && <div className={classes.originalPrice}>{priceFormatter(originalPrice)}</div>}
            {price >= 0 &&
              <div className={classes.affirmMessage}>
                <AffirmContainer price={price} isAffirmEligible={isAffirmEligible} className={classes.affirmMessage} />
              </div>}
            {!seminarInfo && descriptionLabel()}
            {approvalText &&
              <div className={classes.approval} dangerouslySetInnerHTML={{ __html: approvalText }} />}
            {instructorsDetails.length > 0 && buildLabel(
              'Instructor',
              instructorsDetails,
              null, <div className='col-4' />,
            )}
            {Boolean(city) && buildLabel(
              'Location',
              null, (
                <SeminarLocation
                  venue={venue}
                  street={street}
                  city={city}
                  state={state}
                  postalCode={postalCode}
                  venueClass={classes.address}
                  addressClass={classes.address}
                  linkClass={classes.mapLink}
                />
              ), (
                <div className='col-4'>
                  {!isOnlineAddress &&
                    <Default>
                      <Link
                        href={`https://maps.google.com/?q=${street} ${city}, ${state} ${postalCode}`}
                        target='_blank'
                        className={classes.gridLink}
                      >
                        View Map
                      </Link>
                    </Default>}
                </div>
              ),
            )}
            {start && end && buildLabel(
              'Date',
              null, (
                <div>
                  <SeminarDateTime
                    startDate={start}
                    endDate={end}
                    timeZone={timeZone}
                  />
                  <Mobile>
                    {sessions.length > 0 &&
                      <div>
                        <button
                          aria-label='View All'
                          onClick={this.togglePopup}
                          className={classes.gridLink}
                          type='button'
                        >
                          View All
                        </button>
                      </div>}
                  </Mobile>
                </div>
              ), (
                <div className='col-4'>
                  {sessions.length > 0 &&
                    <Default>
                      <button
                        aria-label='View All'
                        onClick={this.togglePopup}
                        className={classes.gridLink}
                        type='button'
                      >
                        View All
                      </button>
                    </Default>}
                </div>
              ),
            )}
          </div>
          {((skillLevel && skillLevel !== 'None') || creditHours.length > 0
            || button || seatsRemaining || showDeliveryType) &&
            <div className={classes.right}>
              {((skillLevel && skillLevel !== 'None') || creditHours.length > 0) &&
                <div className={classes.rightTop}>
                  {skillLevel && skillLevel !== 'None' &&
                    <div className={classes.skillLevelContainer}>
                      <div className={classes.skillLevelHeading}>SKILL LEVEL:</div>
                      <div className={classes.skillLevelWrapper}>
                        {skillLevel}
                      </div>
                    </div>}
                  {showDeliveryType &&
                    <div className={classes.deliveryTypeContainer}>
                      <div className={classes.deliveryTypeHeading}>DELIVERY TYPE:</div>
                      <div className={classes.deliveryTypeWrapper}>
                        {deliveryType}
                      </div>
                    </div>}
                  {creditHours.length > 0 &&
                    <div className={classes.creditHoursContainer}>
                      <div className={classes.creditHoursHeading}>
                        {displayConfiguration === displayType.NASBA ? 'FIELD OF STUDY:' : 'CREDIT HOURS:'}
                      </div>
                      {creditHours.map((o, i) => (
                        <div key={i} className={classes.creditHoursWrapper}>
                          {
                            o.type &&
                            <div className={classes.creditType} dangerouslySetInnerHTML={{ __html: o.type }} />
                          }
                          {o.hours && <div className={classes.creditHours}>{o.hours}</div>}
                        </div>
                      ))}
                    </div>}
                </div>}
              {(seatsLeftLabel || button) &&
                <div className={classes.rightBottom}>
                  {seatsLeftLabel &&
                    <div className={classes.seatsAvailable}>{seatsLeftLabel}</div>}
                  {button && <div className={classes.cartButton}>{BuildChildren(button)}</div>}
                </div>}
            </div>}
        </div>
        {seminarInfo && descriptionLabel()}
        {sessions.length > 0 &&
          <SeminarDetailsModal
            displayName={displayName}
            sessions={sessions}
            isOpen={showPopup}
            closeModal={this.togglePopup}
            timeZone={timeZone}
          />}
      </div>
    );
  }
}

CardProductH.propTypes = {
  /**
   * Product title that displays at the top of the card
  */
  displayName: PropTypes.string,
  /**
   * Product price
  */
  price: PropTypes.number,
  /**
   * Product original price
  */
  originalPrice: PropTypes.number,
  /**
   * Product credit hours
  */
  creditHours: PropTypes.array,
  /**
   * Add to cart button of the product
  */
  button: PropTypes.object,
  /**
   * Product description
  */
  description: PropTypes.string,
  /**
   * Product skill level
  */
  skillLevel: PropTypes.string,
  /**
   * Product approval text
  */
  approvalText: PropTypes.string,
  /**
   * If the product is a seminar this ius the object that hold the details
  */
  seminarInfo: PropTypes.shape({
    street: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    sessions: PropTypes.array,
    instructor: PropTypes.string,
    seatsRemaining: PropTypes.number,
    timeZone: PropTypes.string,
  }),
  /**
   * Product subjects:<br>
   * Array of strings
  */
  subjects: PropTypes.arrayOf(PropTypes.string),
  /**
   * Can you use affirm on this product
  */
  isAffirmEligible: PropTypes.bool,
  /**
   * URL to product detail page
  */
  productDetailUrl: PropTypes.string,
  /**
   * URL to product
  */
  url: PropTypes.string,
  /**
   * Default or NASBA
  */
  displayConfiguration: PropTypes.string,
  /**
   * Product Delivery Type
  */
  deliveryType: PropTypes.string,
};

export default CardProductH;
